import { ActionIcon, Group } from "@mantine/core";
import { ArrowUp, Layers2 } from "lucide-react";

import { ErrorAlert } from "../../../platform/ErrorAlert";
import { Choice } from "../../../ui/Choice";
import { Price } from "../../../ui/Price";
import type { SoundJob } from "./use-sound-job";

/** Live's words on the count, which its API does not let a user change yet. */
const COUNT_TIP = "Select how many sound variations to generate.";

/**
 * The footer's right side, as live's: the count, always 1 and greyed with live's tooltip, the
 * price and the start arrow.
 */
export function StartRow({ job }: { job: SoundJob }) {
  return (
    <Group gap={12} wrap="nowrap">
      <Choice
        setting="Outputs"
        icon={<Layers2 size={20} strokeWidth={1.5} />}
        width={56}
        chevron={false}
        value="1"
        options={[{ value: "1", label: "1" }]}
        onChange={() => undefined}
        disabledBecause={COUNT_TIP}
      />
      <Price priced={job.priced} pending={job.pricing} />
      <ActionIcon
        variant="filled"
        size="lg"
        radius="100%"
        aria-label="Start"
        disabled={!job.canStart}
        loading={job.start.isPending}
        onClick={job.startJob}
      >
        <ArrowUp size={20} />
      </ActionIcon>
    </Group>
  );
}

/** A failed quote or start, said under the prompt. */
export function SoundErrors({ job }: { job: SoundJob }) {
  return (
    <>
      {job.quoteError === null ? null : <ErrorAlert error={job.quoteError} />}
      {job.start.isError ? <ErrorAlert error={job.start.error} /> : null}
    </>
  );
}
